import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/lang";
import { Eyebrow } from "@/components/Reveal";

const LegalPage = ({ type }) => {
  const { t, scrollTo } = useLang();
  const c = type === "legal" ? t.legal : t.privacy;

  useEffect(() => {
    scrollTo(0);
  }, [type]);

  return (
    <div data-testid={`${type}-page`} className="min-h-screen bg-white">
      <section className="relative overflow-hidden bg-bei-navy pb-14 pt-36 sm:pb-16 sm:pt-44">
        <div className="grid-overlay absolute inset-0" />
        <div className="absolute -right-32 top-0 h-[360px] w-[360px] rounded-full bg-bei-brand/20 blur-[140px]" />
        <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          >
            <Eyebrow>{c.eyebrow}</Eyebrow>
            <h1 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
              {c.title}
            </h1>
            <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
              {c.updated}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-14 sm:py-20">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid={`${type}-back-link`}
            className="group inline-flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-bei-brand transition-colors hover:text-bei-cyan"
          >
            <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
            {c.back}
          </Link>

          <div className="mt-12 space-y-10">
            {c.sections.map((s, i) => (
              <motion.div
                key={i}
                data-testid={`${type}-section-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.04 }}
                className="border-l-2 border-bei-cyan/40 pl-6"
              >
                <h2 className="font-display text-xl font-bold tracking-tight text-bei-navy sm:text-2xl">
                  {s.h}
                </h2>
                <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-slate-600 sm:text-base">
                  {s.p}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;
